import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { getProperty } from '../../modules/ajio-util/properties';
import {
  getAjioSuperCashCurrencyConfig,
  getAjioSuperCashEnable
} from '../../refresh/selectors/featureFlagsSelector';
import { gtmEventPush } from '../../modules/ga/GTMdatalayer';

const ReferralCongratulations = props => {
  const { referralCongratsMessageTimer, ajioSuperCashCurrencyConfig, ajioSuperCashEnable = false } = props;
  const [showReferralSuccess, setShowReferralSuccess] = useState(false);
  const [referralSuccessMessage, setReferralSuccessMessage] = useState(null);
  const { currencyName = 'SuperCash' } = ajioSuperCashCurrencyConfig || {};
  const referralCurrency = ajioSuperCashEnable ? currencyName : 'SuperCash';
  const removeReferralSuccessMsg = useCallback(e => {
    setReferralSuccessMessage(null);
    e.stopPropagation();
  }, []);

  useEffect(() => {
    if (window?.sessionStorage) {
      const referralSuccessMsgEncoded = window.sessionStorage.getItem('refInc');
      let referralSuccessMsg = null;
      try {
        if (referralSuccessMsgEncoded) {
          const stringifiedMsgObject = decodeURIComponent(atob(referralSuccessMsgEncoded));
          referralSuccessMsg = JSON.parse(stringifiedMsgObject);
        }
      } catch (error) {
        referralSuccessMsg = null;
      }
      window.sessionStorage.removeItem('refInc');
      if (referralSuccessMsg) {
        gtmEventPush({
          event: 'referral_widget_impression',
          event_category: 'screenInteraction',
          event_action: 'widget impression',
          event_label: 'congratulations widget',
          AJIO_Referral: 'congratulations widget - viewed'
        });
        setReferralSuccessMessage(referralSuccessMsg);
      }
    }
  }, []);

  useEffect(() => {
    if (
      referralSuccessMessage?.expiresInMessage?.includes('*expires in 0 .') ||
      referralSuccessMessage?.cashMessage?.includes(`Your friend has given you 0* ${referralCurrency}.`)
    ) {
      setShowReferralSuccess(false);
    } else if (referralSuccessMessage) {
      setShowReferralSuccess(true);
      setTimeout(() => {
        setReferralSuccessMessage(null);
      }, referralCongratsMessageTimer);
    } else {
      setShowReferralSuccess(false);
    }
  }, [referralSuccessMessage]);
  if (showReferralSuccess) {
    return (
      <section className="referral-congrats">
        <aside>
          <img
            src={`${getProperty('imageBaseUrl')}/static/img/referral-widget-icon.png`} // verify after uploaded
            alt="Refer Ajio to friends icon"
          />
        </aside>
        <main>
          <h3>Congratulations!</h3>
          {referralSuccessMessage?.cashMessage ? (
            <h5>{referralSuccessMessage.cashMessage}</h5>
          ) : null}
          {referralSuccessMessage?.expiresInMessage ? (
            <h5>{referralSuccessMessage.expiresInMessage}</h5>
          ) : null}
        </main>
        <button
          type="button"
          onClick={e => {
            gtmEventPush({
              event: 'buttonTap',
              event_category: 'buttonTap',
              event_action: 'referral card clicked',
              event_label: 'congratulations widget',
              AJIO_Referral: 'congratulations widget - clicked'
            });
            removeReferralSuccessMsg();
          }}
        >
          <img
            src={`${getProperty('imageBaseUrl')}/static/img/cross-Icon-refresh.svg`}
            alt="Close"
          />
        </button>
      </section>
    );
  }

  return null;
};

const mapStateToProps = state => {
  const { flags = {} } = state;
  const { referralCongratsMessageTimer = 15000 } = flags;
  const ajioSuperCashCurrencyConfig = getAjioSuperCashCurrencyConfig(state?.flags);
  const ajioSuperCashEnable = getAjioSuperCashEnable(state?.flags);
  return { referralCongratsMessageTimer, ajioSuperCashCurrencyConfig, ajioSuperCashEnable };
};

export default connect(mapStateToProps)(ReferralCongratulations);